import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowUpCircle } from 'lucide-react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, cn } from '@airia/ui';
const UploadFile = ({ onFileAttach }) => {
    const onDrop = useCallback((acceptedFiles) => {
        onFileAttach(acceptedFiles[0]);
    }, [onFileAttach]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    return (_jsxs("div", { ...getRootProps(), className: cn('w-full h-full flex flex-col justify-center items-center gap-10 rounded-lg border-4 border-dashed', { 'bg-primary-100': isDragActive }), children: [_jsx(ArrowUpCircle, { className: 'size-24 text-primary' }), _jsx("input", { ...getInputProps() }), _jsxs("div", { className: 'flex flex-col gap-2 justify-center', children: [_jsx("span", { className: 'text-foreground', children: `Drag your files here to upload or` }), _jsx(Button, { className: 'rounded-md', variant: 'secondary', children: "Browse files" })] })] }));
};
export default UploadFile;
